import LocalStoragePersistence from "../localStoragePersistence/common/LocalStoragePersistence";
import { deleteAllCaches } from "../offline/CacheManager";

export class LocalDataRemover {
  public removeAllLocalData(): Promise<void> {
    return deleteAllCaches().then((result) => {
      if (result) {
        new LocalStoragePersistence().clearLocalStorageWithExceptions();
      } else {
        throw new Error("Error while deleting cache (browser cache api).");
      }
    });
  }
}
